import {createSlice} from "@reduxjs/toolkit";
import {addError} from "src/slices/errors";
import {getUserDetails} from "src/api/user";

const initialState = {
    isDeleteUserStarted: false,
    isEditUserStarted: false,
    isCreateUserStarted: false,
    isModalOpen: false,
    currentUser: {},
    loadingCurrentUser: false
};

const slice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser(state, action) {
            const {currentUser} = action.payload;
            state.currentUser = currentUser;
        },
        setLoadingCurrentUser(state, action) {
            state.loadingCurrentUser = action.payload;
        },
        openModal(state) {
            state.isModalOpen = true;
        },
        closeModal(state) {
            state.isModalOpen = false;
            state.currentUser = {};
        },
        selectUser(state, action) {
            const {user} = action.payload;
            state.currentUser = user;
        },
        setDeletingUser(state, action) {
            const {isStarted} = action.payload;
            state.isDeleteUserStarted = isStarted;
        },
        setEditingUser(state, action) {
            const {isStarted} = action.payload;
            state.isEditUserStarted = isStarted;
        },
        setCreatingUser(state, action) {
            const {isStarted} = action.payload;
            state.isCreateUserStarted = isStarted;
        }
    }
});

export const reducer = slice.reducer;

export const getUser = userId => async dispatch => {
    dispatch(slice.actions.setLoadingCurrentUser(true));

    let currentUser = initialState.currentUser;
    try {
        const response = await getUserDetails(userId)
        currentUser = response.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setUser({currentUser}));
    dispatch(slice.actions.setLoadingCurrentUser(false));
};

export const setCreatingUser = isStarted => dispatch => {
    dispatch(slice.actions.setCreatingUser({isStarted}));
};

export const setEditingUser = isStarted => dispatch => {
    dispatch(slice.actions.setEditingUser({isStarted}));
};

export const openModal = user => dispatch => {
    dispatch(slice.actions.selectUser({user}));
    dispatch(slice.actions.openModal());
};

export const closeModal = () => dispatch => {
    dispatch(slice.actions.closeModal());
};

export const setDeletingUser = isStarted => dispatch => {
    dispatch(slice.actions.setDeletingUser({isStarted}));
};